import * as DashboardConstants from '.././DashboardConstants';

export const slaByPriorityTableHeaders = [
    {
        key: "item",
        header: DashboardConstants.Month
    },
    {
        key: "total",
        header: DashboardConstants.Total
    },
    {
        key: "response",
        header: DashboardConstants.MetResponseSLA
    },
    {
        key: "resolution",
        header: DashboardConstants.MetResolutionSLA
    },
    {
        key: "responsePercentage",
        header: DashboardConstants.MetResponseSLAPercentage
    },
    {
        key: "resolutionPercentage",
        header: DashboardConstants.MetResolutionSLAPercentage
    }
];

export const slaByFranchiseTableHeaders = [
    {
        key: "item",
        header: DashboardConstants.Franchise
    },
    {
        key: "total",
        header: DashboardConstants.Total
    },
    {
        key: "response",
        header: DashboardConstants.MetResponseSLA
    },
    {
        key: "resolution",
        header: DashboardConstants.MetResolutionSLA
    },
    {
        key: "responsePercentage",
        header: DashboardConstants.MetResponseSLAPercentage
    },
    {
        key: "resolutionPercentage",
        header: DashboardConstants.MetResolutionSLAPercentage
    }
];

export const slaByIncidentTableHeaders = [
    {
        key: "incident_no",
        header: DashboardConstants.IncidentNo
    },
    {
        key: "status",
        header: DashboardConstants.Status
    },
    {
        key: "created_time",
        header: DashboardConstants.CreatedTimeSLA
    },
    {
        key: "assigned_time",
        header: DashboardConstants.AssignedTime
    },
    {
        key: "resolved_time",
        header: DashboardConstants.ResolvedTime
    },
    {
        key: "on_hold_duration",
        header: DashboardConstants.OnHoldDur
    }
];



export const slaByIncidentTableData =[
    {
        "incident_no": "INC1831943",
        "status": "Resolved",
        "created_time": "2022-04-06 00:00:28",
        "assigned_time": "2022-04-06 00:01:28",
        "resolved_time": "2022-04-06 00:52:07",
        "on_hold_duration": "43 Minutes"
    },
    {
        "incident_no": "INC1831944",
        "status": "Resolved",
        "created_time": "2022-04-06 00:01:21",
        "assigned_time": "2022-04-06 00:02:37",
        "resolved_time": "2022-04-06 17:32:36",
        "on_hold_duration": "16 Hours 28 Minutes"
    },
    {
        "incident_no": "INC1831945",
        "status": "Resolved",
        "created_time": "2022-04-06 00:02:36",
        "assigned_time": "2022-04-06 00:11:57",
        "resolved_time": "2022-04-06 02:35:43",
        "on_hold_duration": "2 Hours 21 Minutes"
    },
    {
        "incident_no": "INC1831946",
        "status": "New",
        "created_time": "2022-04-06 00:05:14",
        "assigned_time": "2022-04-06 00:11:57",
        "resolved_time": "2022-04-06 02:35:43",
        "on_hold_duration": "2 Hours 21 Minutes"
    },
    {
        "incident_no": "INC1831947",
        "status": "Resolved",
        "created_time": "2022-04-06 00:05:24",
        "assigned_time": "2022-04-06 00:08:17",
        "resolved_time": "2022-04-06 00:51:00",
        "on_hold_duration": "41 Minutes"
    },
    {
        "incident_no": "INC1831948",
        "status": "Resolved",
        "created_time": "2022-04-06 00:08:22",
        "assigned_time": "2022-04-06 00:12:01",
        "resolved_time": "2022-04-06 02:34:58",
        "on_hold_duration": "14 Minutes"
    }
]


export const slaTicketResponseDownloadbaleHeader = [
    { key: 'group', header: DashboardConstants.Priority },
    { key: 'key', header: DashboardConstants.Time },
    { key: 'value', header: DashboardConstants.ResponseSLAMetPercentage }
];
